// Copyright text placeholder, Warner Bros. Discovery, Inc.

/**
 *  WARNING:
 *  This file is auto-generated. Do not edit manually. Any changes made to this
 *  file will be overwritten the next time it is generated. If you need to make
 *  changes, please modify the source files and re-generate this file.
 */

import { BaseEvent, IVersionedEvent } from '../../../core';

/**
 * http method used to make the request
 * @public
 * @readonly
 */

enum MethodV1 {
  /** Method of GET **/
  GET = 'GET',
  /** Method of POST **/
  POST = 'POST',
  /** Method of PUT **/
  PUT = 'PUT',
  /** Method of DELETE **/
  DELETE = 'DELETE',
  /** Method of PATCH **/
  PATCH = 'PATCH'
}

/**
 *
 *
 * version 1.0
 * @public
 */
interface IPageV1 {
  /** The relative url of the page **/
  uri: string;
  /** Canonical pageId of the currently rendered page. Canonical pageIds must be consistent across all implementations of Beam; we achieve this by using CMS-provided values where possible. **/
  id?: string;
}

/**
 *
 *
 * version 1.0
 * @public
 */
interface IRequestV1 {
  /** unix timestamp when the request was initiated. Expected to be unreliable due to device skew. **/
  deviceSentAt: number;
  /** http method used to make the request **/
  method: MethodV1;
  /** How many retries have been initiated for this request. **/
  retryCount: number;
  /** unique identifier for the request **/
  traceId: string;
  /** the full url where the request was made to **/
  url: string;
}

/**
 *
 *
 * version 1.0
 * @public
 */
interface IErrorCodesV1 {
  /** service error code provided by the response payload **/
  code: string;
  /** Unique identifier from service for the matching code **/
  id: string;
}

/**
 *
 *
 * version 1.0
 * @public
 */
interface IResponseV1 {
  /** unix timestamp when the response was received. Expected to be unreliable due to device skew. **/
  deviceReceivedAt: number;
  /** A numerical value that is returned by a server in response to a client&#x27;s request. Restricted to the 4xx and 5xx ranges. **/
  statusCode: number;
  /**  **/
  errorCodes?: IErrorCodesV1[];
}

/**
 *
 *
 * version 1.0
 * @public
 */
interface IMeasureV1Payload {
  /** delta between the response.deviceSentAt and the request.deviceReceivedAt in milliseconds, OR can use an internal sentTimestamp and receivedTimestamp on some devices (web) for greater accuracy using: https://developer.mozilla.org/en-US/docs/Web/API/DOMHighResTimeStamp **/
  duration: number;
  /**  **/
  page: IPageV1;
  /**  **/
  request: IRequestV1;
  /**  **/
  response: IResponseV1;
}

/**
 * RequestMeasureV1 event
 * An event emitted after the client makes a request to an internal service endpoint. This contains metadata from the request and its timings and empowers the following metrics.
 * @public
 */
export class RequestMeasureV1 extends BaseEvent<IMeasureV1Payload> {
  /** unique event type **/
  public readonly eventType: string = 'beam.events.request.measure_1.0';
  /** http method used to make the request **/
  public static METHOD: typeof MethodV1 = MethodV1;

  /**
   * overrides the default _build method to add default values for fields
   * @param payload - The payload for this event.
   * @returns IVersionedEvent<IMeasureV1Payload>
   */
  protected override _build(payload: IMeasureV1Payload): IVersionedEvent<IMeasureV1Payload> {
    return super._build({
      ...payload
    });
  }
}

export { MethodV1 as RequestMeasureV1Method };
export type { IPageV1 as IRequestMeasureV1Page };
export type { IRequestV1 as IRequestMeasureV1Request };
export type { IErrorCodesV1 as IRequestMeasureV1ErrorCodes };
export type { IResponseV1 as IRequestMeasureV1Response };
export type { IMeasureV1Payload as IRequestMeasureV1Payload };
